import { render, staticRenderFns } from "./ChannelCategoryStatuses.vue?vue&type=template&id=68016500&"
import script from "./ChannelCategoryStatuses.vue?vue&type=script&lang=js&"
export * from "./ChannelCategoryStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSheet,VTooltip})
